import { useState } from 'react'
import { useEffect, useMemo } from 'react'
import * as XLSX from 'xlsx'

import type { GetBinaryFileContentResponse } from 'services/results/types'

export const useRenderXLSX = (data?: GetBinaryFileContentResponse) => {
  const [sheetNames, setSheetNames] = useState<string[]>([])
  const [selectedSheetName, setSelectedSheetName] = useState<string>('')
  const [tableHTML, setTableHTML] = useState<string>('')
  const [isLoading, setIsLoading] = useState<boolean>(true)
  const [error, setError] = useState<string | null>(null)

  const workbook = useMemo(() => {
    if (!data) return null

    try {
      const workbookData = XLSX.read(data.fileContent, { type: 'binary' })
      setSelectedSheetName(workbookData.SheetNames[0])
      setSheetNames(workbookData.SheetNames)
      setError(null)
      return workbookData
    } catch (error) {
      setError('Error loading file')
      return null
    }
  }, [data])

  useEffect(() => {
    if (!workbook) return
    setIsLoading(true)
    const sheetName = selectedSheetName || workbook.SheetNames[0]
    const sheet = workbook.Sheets[sheetName]

    try {
      const tableHTML = XLSX.utils.sheet_to_html(sheet)
      setTableHTML(tableHTML)
      setIsLoading(false)
      setError(null)
    } catch (error) {
      setError('Error loading file')
      setIsLoading(false)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [workbook, selectedSheetName])

  return {
    error,
    tableHTML,
    isLoading,
    selectedSheetName,
    setSelectedSheetName,
    sheetNames
  }
}
